import { trackEvent } from './ComponentHelper'

const buildEventInfo = (eventName, eventData, eventAction) => {
  return {
    eventInfo: {
      eventName,
      eventAction,
      ...eventData
    }
  }
}

const buildAttributes = (attributeData) => {
  return attributeData ? { attributes: { ...attributeData } } : null
}

const trackDataLayerEvent = (eventName, eventData, attributeData, eventAction = 'cms interaction') => {
  trackEvent(
    {
      ...buildEventInfo(eventName, eventData, eventAction),
      ...buildAttributes(attributeData)
    },
    window
  )
}

const joinLinkTitles = (links, linkTitlesArray) => {
  if (links === null || links.length === 0) {
    return 'NA'
  }

  links.map((linkElement) => linkTitlesArray.push(linkElement?.title || linkElement?.linkTitle))

  return linkTitlesArray.join('|')
}

const createGolDataAttributes = (
  consumingGridType = 'isolated',
  componentType = 'component - NA', // component type + position in grid
  title = 'NA', // linkTitle
  link,
  parentHeading, // component heading
  action = 'Click',
  event = 'ev_cmsComponentClick'
) => {
  const isLoad = action === 'Load'
  const isM022 = componentType === 'M022 - NA'
  if (!link && isLoad && !isM022) return {}

  return {
    'data-name': isLoad ? 'ev_cmsComponentLoad' : event,
    'data-category': 'CMS Component',
    'data-action': action,
    'data-label': `${consumingGridType} - ${componentType} - ${title}`,
    ...(link && !isLoad && { 'data-destination': link }),
    ...(parentHeading && !isLoad && { 'data-parent': parentHeading })
  }
}

const eventNames = {
  afsBannerInView: 'afsBannerViewed',
  afsBannerClicked: 'afsBannerClicked',
  afsDrawerCloseX: 'afsCreditPlan_Close',
  afsDrawerCloseKeepOnShopping: 'afsCreditPlan_KeepOnShopping',
  afsOffersHereClicked: 'afsCreditPlan_OffersHere',

  cmsStickyBarAnchorLink: 'cmsStickyBarAnchorLink',

  hotspotClicked: 'hotspotClicked',
  cmsAccordionOpen: 'accordionOpen',
  cmsAccordionClose: 'accordionClose',
  expandCmsAccordion: 'Expand accordion',
  collapseCmsAccordion: 'Collapse accordion',
  carouselViewed: 'cms_carousel_viewed',
  carouselInteraction: 'cms_carousel_interaction'
}

const attributeNames = {
  hotspotComponentId: 'hotspotComponentId',
  accordion: 'accordion'
}

export { trackDataLayerEvent, createGolDataAttributes, eventNames, attributeNames, joinLinkTitles }
